import React, { FC, PropsWithChildren, createContext, useState } from 'react';

interface NavigationMenuVisibilityContextProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export const NavigationMenuVisibilityContext = createContext<NavigationMenuVisibilityContextProps>({
  visible: true,
  setVisible: () => {},
});

export const NavigationMenuVisibilityProvider: FC<PropsWithChildren> = ({ children }) => {
  const [visible, setVisible] = useState(true);

  return (
    <NavigationMenuVisibilityContext.Provider value={{ visible, setVisible }}>
      {children}
    </NavigationMenuVisibilityContext.Provider>
  );
};
